import * as React from 'react'
import styled from 'styled-components'
import { fontSizes } from '@src/styles/theme'

const Container = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
`

const Title = styled.h3<any>`
  font-family: 'NunitoSansSemiBold';
  font-size: ${fontSizes.S};
  color: ${(props: any) => props.theme.white};
  margin: 0 0 8px 0;
`

const Description = styled.p<any>`
  font-size: ${fontSizes.XXS};
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
  margin: 0 0 24px 0;
  max-width: 420px;
  line-height: 1.5;
`

export interface EmptyStateProps {
  title: string
  description?: string
  children?: React.ReactNode
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, children }) => {
  return (
    <Container>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
      {children}
    </Container>
  )
}
